import { useState, useEffect } from "react";
import { Col, Row, Container, Collapse } from "reactstrap";
import "../../../../features2/recommendation/recommendationJozunaView/styles/JozunaViewStyles.css";
import arrowImg from "../../assets/images/JozunaView/arrowImg.png"; // Import the image
import { useLocation, useNavigate } from "react-router-dom";
import VideoImageOverlay from "./../../recommendation_industry_view/components/VideoImage_Overlay";
import NewImage from "../../recommendation_industry_view/components/New_Image";
import { useApi } from "../../../../service/ApiContext";
import strings from "../../../../utils/Strings";
import Loader, { LocalStorage } from "../../../../utils/Utils";
import {
  CourseTopic,
  CourseTopicListResponse,
} from "../../recommendation_industry_view/data/response/Course_Topic_Response";
import RecommendationIndustryViewClient from "../../recommendation_industry_view/data/api_client/Recommendation_IndustryView_Client";
import { NoTopicsFound } from "../../recommendation_industry_view/components/NoRecords_Found";
import BlueVerticalDivider from "../../recommendation_industry_view/components/Blue_Vertical_Divider";
import { recommendationJozunaViewInstance_Store } from "../data/instance_store/Recommendation_JozunaView_Instance";
import { TopicVideoResponse } from "../../recommendation_industry_view/data/response/Topic_Videos_Response";
import CommonUtils from "../../../../utils/Common_Utils";
import Logger from "../../../../utils/Logger";
import { TopicNameTitleTextComponent } from "../../recommendation_industry_view/components/TopicNameTittleText";
import RecommendationViewHeader from "../../../../features2/recommendation/recommendation_industry_view/components/Recommendation_View_Header";
import infoImg from "../../assets/images/info 1.png";
import GreyHorizontalDivider from "../../recommendation_industry_view/components/grey_Horizontal_Divider";
import { Box, MenuItem, Popover } from "@mui/material";
import { RootState } from "../../../../store/store";
import { useDispatch, useSelector } from "react-redux";
import { setJozunaSelectedProgram } from "../../vedio-recommendation/data/redux/JozunaDropdown";
import {
  Recommendation,
  videoLandingPageResponse,
} from "../../vedio-recommendation/data/response/VideoLandingPageResponse";
import VideoLandingPageClient from "../../vedio-recommendation/data/api/VideoLandingPageClient";
import { useAlert } from "../../../../components/AlertContextComponent";
import { videolandingPageRequest } from "../../vedio-recommendation/data/request/VideoLandingPageRequest";
import DropDown from "../../assets/images/dropdown.svg";
import { recommendationIndustryViewInstance_Store } from "../../recommendation_industry_view/data/instance_store/Recommendation_IndustryView_Instance";
import dotImg from "../../assets/images/dotIcon.png";
import backArrowImg from "../../assets/images/common/recommand_right-arrow.png";

type VideoLandingPageProps = {
  activeTb: number; // Adjust the type as needed
};
const RecommendationJozunaViewCoursePage: React.FC<VideoLandingPageProps> = ({
  activeTb,
}) => {
  //Initial Method

  // Declarations
  const api = useApi();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { state } = location;
  const [selectedItem, setSelectedItem] = useState<CourseTopic>();
  const [details, setDetails] = useState<TopicVideoResponse>();
  const [openDetailIndex, setOpenDetailIndex] = useState<number | null>(null);
  const [topicduration, setTopicduration] = useState<number>();
  const [topicList, setTopicList] = useState<CourseTopic[]>();
  const [totVideos, setTotVideos] = useState(null);
  const [selectedTopic, setSelectedTopic] = useState<any>(null);
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [selectedCourseInfo, setSelectedCourseInfo] = useState<any>(null);
  //Api Calls
  const getCourseTopic = async (courseId: string, programId: string) => {
    Loader.showLoading(strings.loading);
    api.setAuthToken(LocalStorage.getLocalData("access_token"));
    setLoading(true);
    try {
      const response = await api.get<CourseTopicListResponse>(
        RecommendationIndustryViewClient.getCourseToipcUrl,
        {
          course_id: state.courseId, // ✅ DIRECT VALUE
          program_id: state.programId, // ✅ DIRECT VALUE
          program_category: "Jozuna",
        },
      );

      setTotVideos(response.data.total_videos ?? null);
      setTopicList(response.data.list_topics);
      setTopicduration(response.data.total_duration);

      if (response.data.list_topics?.length > 0) {
        const firstTopic = response.data.list_topics[0];
        setSelectedItem(firstTopic);
        setSelectedTopic(firstTopic);
        getTopicVideos(firstTopic.topic_id, state.courseId, state.programId); // pass forward
      } else {
        setSelectedTopic(null);
        setDetails(undefined);
      }
    } catch (error) {
      Logger.error("Error fetching Course Topics:", error);
    } finally {
      setLoading(false);
      Loader.dismissLoading();
    }
  };
  const getTopicVideos = async (
    topicId: string,
    courseId: string,
    programId: string,
  ) => {
    Loader.showLoading(strings.loading);
    api.setAuthToken(LocalStorage.getLocalData("access_token"));
    setLoading(true);
    try {
      const response = await api.get<TopicVideoResponse>(
        RecommendationIndustryViewClient.getCourseVideoUrl,
        {
          course_id: courseId,
          topic_id: topicId,
          program_id: state.programId, // ✅ DIRECT VALUE
          program_category: "Jozuna",
        },
      );

      setDetails(response.data);
    } catch (error) {
      Logger.error("Error fetching Course Videos:", error);
    } finally {
      setLoading(false);
      Loader.dismissLoading();
    }
  };
  //Methods
  const handleTopicClick = (topic: CourseTopic) => {
    if (!topic?.topic_id) return;

    getTopicVideos(
      topic.topic_id,
      state.courseId,
      selectedOptionJozuna?.id || selectedOption?.id || "",
    );
  };
  const handleItemClick = async (item: CourseTopic, isNullOpen: boolean) => {
    console.log("Clicked topic:", item); // ✅ debug

    setSelectedItem(item); // ✅ direct update (no store delay)
    setSelectedTopic(item);

    // ❗ Pass full item (or ensure id exists)
    if (!item?.topic_id) {
      console.error("topic_id missing!", item);
      return;
    }

    handleTopicClick(item); // ✅ pass full object

    if (isNullOpen) {
      recommendationJozunaViewInstance_Store.setOpenedIndex(null);
      setOpenDetailIndex(null);
    }
  };
  const { showAlert } = useAlert();
  const [programOptionsJozuna, setProgramOptionsJozuna] = useState<
    { id: string; title: string; description: string }[]
  >([]);
  const [activeTab, setActiveTab] = useState(activeTb);
  const [loading, setLoading] = useState(false);
  const [anchorEl2, setAnchorEl2] = useState<null | HTMLElement>(null);
  const selectedProgram = useSelector(
    (state: RootState) => state.JozunaDropdown.JozunaSelectedProgram,
  );
  const [selectedOptionJozuna, setSelectedOptionJozuna] = useState<{
    id: string;
    title: string;
    description: string;
  } | null>(null);
  const [programOptions, setProgramOptions] = useState<
    { id: string; title: string; description: string }[]
  >([]);
  const [selectedOption, setSelectedOption] = useState<{
    id: string;
    title: string;
    description: string;
  } | null>(null);
  const [assessmentFound, setAssessmentFound] = useState(false);
  const [cardData, setCardData] = useState<Recommendation[] | null>(null);
  const [jozunaRecommendation, setJozunaRecommendation] = useState<string>("");
  const [industry, setIndustryData] = useState<Recommendation[] | null>(null);
  const [industryDuration, setIndustryDuration] = useState(0);
  const [jozunaDuration, setJozunaDuration] = useState(0);
  const [selectedId, setSelectedId] = useState("");
  const [selectedDesc, setSelectedDesc] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [Apptoken, setAppToken] = useState<string | null>(null);

  const handleClose2 = () => {
    setAnchorEl2(null);
  };
  // Select the data from the Redux store
  const userData = useSelector((state: RootState) => state.profile.profileKeys);
  const handleClickDrop = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl2(event.currentTarget);
  };
  const getProgram = async () => {
    Loader.showLoading("Loading...");
    setLoading(true);

    api.setAuthToken(LocalStorage.getLocalData("access_token"));
    const param = {
      domain_name: activeTab === 0 ? "Jozuna" : "Industry",
      offset_time: "+5:30",
    };

    try {
      const response = await api.get<any>("/assessment/names", param);

      // Dispatch programs to Redux store
      Logger.info("response for details", response.data);

      // Map program data to options
      const options = response.data.assessment_names.map((program: any) => ({
        id: program.assessment_entity_id,
        title: program.assessment_name,
        // description: program.program_description,
      }));

      if (options.length === 0) return;

      // ✅ Always pick first option if nothing selected
      // const defaultOption = selectedProgram ?? options[0];

      // get assessment_id from route state
      const stateAssessmentId = state?.assessment_id;

      // try to match assessment_entity_id from API
      const matchedOption = stateAssessmentId
        ? options.find((opt: { id: any }) => opt.id === stateAssessmentId)
        : null;

      // final default selection

      // 1️⃣ Try Redux
      const reduxMatch = selectedProgram
        ? options.find((opt: { id: any }) => opt.id === selectedProgram.id)
        : null;

      // 2️⃣ Try route state
      const routeMatch = stateAssessmentId
        ? options.find((opt: { id: any }) => opt.id === stateAssessmentId)
        : null;

      // 3️⃣ Final fallback
      const defaultOption = reduxMatch ?? routeMatch ?? options[0];

      // // Set options based on activeTab
      // if (activeTab === 0) {
      //   setProgramOptionsJozuna(options);
      // } else {
      //   setProgramOptions(options);
      // }

      if (activeTab === 0) {
        setProgramOptionsJozuna(options);
        setSelectedOptionJozuna(defaultOption);
      } else {
        setProgramOptions(options);
        setSelectedOption(defaultOption);
      }

      dispatch(setJozunaSelectedProgram(defaultOption));
      Logger.info("defaultOption", defaultOption);
      getCourseDetail(activeTab, defaultOption.id);

      // // Find the active program
      // const activeProgram =
      //   response.data.assessment_names.find(
      //     (program: any) => program.status === "Active"
      //   ) || response.data.programs[0];

      // if (activeProgram) {
      //   const selectedOption = {
      //     id: selectedProgram?.id,
      //     title: selectedProgram?.description,
      //     description: selectedProgram?.title,
      //   };

      //   const id = selectedProgram?.id;
      //   const desc = selectedProgram?.description;
      //   setSelectedDesc(desc);

      //   Logger.info("idd", id);

      //   // Set selected option based on activeTab
      //   if (activeTab === 0) {
      //     setSelectedOptionJozuna(selectedOption);
      //   } else {
      //     setSelectedOption(selectedOption);
      //     setSelectedId(id);
      //   }

      //   Logger.info("Selected Options:", selectedOption);
      //   Logger.info("Selected Options id:", selectedId);

      //   Logger.info("Selected Jozuna Options:", selectedOptionJozuna);

      //   // if (!selectedProgram) {
      //   //   dispatch(setJozunaSelectedProgram(selectedOption));
      //   // }

      //   // // Call getEvents only after setting selectedOption
      //   // getCourseDetail(activeTab, id);

      //   if (!selectedProgram) {
      //     console.log("first options");
      //     const firstOption = options[0]; // Select the first program by default
      //     setSelectedDesc(firstOption.description);
      //     if (activeTab === 0) {
      //       setSelectedOptionJozuna(firstOption);
      //     } else {
      //       setSelectedOption(firstOption);
      //     }
      //     dispatch(setJozunaSelectedProgram(firstOption)); // Dispatch to Redux
      //     getCourseDetail(activeTab, firstOption.id); // Load the corresponding course
      //   } else {
      //     getCourseDetail(activeTab, id);
      //   }
      // }
    } catch (error) {
      Logger.info("error response", error);
      // Display an error alert or message if needed
    } finally {
      Loader.dismissLoading();
      setLoading(false);
    }
  };
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };
  const query = useQuery();
  useEffect(() => {
    const tokenFromURL = query.get("token");
    const regionFromURL = query.get("region");
    // Handling token
    if (tokenFromURL) {
      Logger.info("Token successfully retrieved from URL:", tokenFromURL);
      LocalStorage.setLocalData("access_token", tokenFromURL); // Store token in local storage
      LocalStorage.setLocalData("fromFlutter", "true");
    } else {
      Logger.info("No token found in URL. Using appToken:");
      const storedToken = LocalStorage.getLocalData("access_token");
      Logger.info(
        "No token found in URL. Using appToken**************:",
        storedToken,
      );

      if (storedToken) {
        setAppToken(storedToken); // Use the token from local storage if not found in URL
        LocalStorage.setLocalData("access_token", storedToken);
      }
    }

    // Handling region
    if (regionFromURL) {
      Logger.info("Region successfully retrieved from URL:", regionFromURL);
      LocalStorage.setLocalData("region", regionFromURL); // Store region in local storage
      LocalStorage.setLocalData("fromFlutter", "true");
    } else {
      Logger.info("No region found in URL.");
    }
    // Check if data for the current tab has already been loaded
    if (
      (activeTab === 0 && jozunaRecommendation !== "jozuna") ||
      (activeTab === 1 && !industry)
    ) {
      getProgram();
    }
    return () => {
      recommendationIndustryViewInstance_Store.clearState(); //Clean Up Recommendation Industry View SelectedItem
      recommendationJozunaViewInstance_Store.clearState(); //Clean Up Recommendation Jozuna View SelectedItem
    };
  }, [activeTab, jozunaRecommendation, industry]);
  const handleOptionChange = (
    option: {
      id: string;
      title: string;
      description: string;
    },
    tab: number,
  ) => {
    if (tab === 0) {
      setSelectedOptionJozuna(option);
      // dispatch(setJozunaSelectedProgram(option));
      Logger.info("option", selectedProgram);
    }
    if (tab === 1) {
      setSelectedOption(option);
      // dispatch(setSelectedOptions(option)); // Redux action for other tabs
      // dispatch(setJozunaSelectedProgram(option));
    }
    setSelectedId(option.id);
    getCourseDetail(activeTab, option.id);
    setSelectedDesc(option.description);
    setAnchorEl2(null);
    Logger.info("selected option", selectedOption);
    Logger.info("selected Idd", selectedId);
    dispatch(setJozunaSelectedProgram(option)); // Save the selected program to Redux
    setIsOpen(false);
  };
  const getCourseDetail = async (tab: number, id: string) => {
    Loader.showLoading("Loading...");
    setLoading(true);
    const param: videolandingPageRequest = {
      recommendation_type: tab == 0 ? "Jozuna" : "Industry",
      program_id: id,
    };
    Logger.info("param", param);
    Logger.info("Selected options", selectedOption?.title);

    api.setAuthToken(LocalStorage.getLocalData("access_token"));

    try {
      const response = await api.get<videoLandingPageResponse>(
        VideoLandingPageClient.landingPageURL,
        param,
      );
      Logger.info("response", response.data);
      if (response.data.error != null) {
        showAlert({
          show: true,
          title: "Error",
          message: response.data.error,
          button1Text: "Cancel",
          alertType: "error",
          onlyNeedOneButton: true,
          btn1onPressed: () => {
            ("");
          },
        });
      } else if (
        response.data.recommendation.length === 0 &&
        response.data.error == null
      ) {
        setAssessmentFound(true);
      } else {
        setAssessmentFound(false);
      }
      const courseData = response.data.recommendation || [];
      const type = response.data.recommendation_type.toLowerCase();
      const sortedCourseData = courseData.sort(
        (a, b) => a.seq_number - b.seq_number,
      );
      // Sort the courseData immediately before setting it to state
      if (type === "industry") {
        setIndustryData(sortedCourseData);
        setIndustryDuration(response.data.total_duration);
      } else if (type === "jozuna") {
        setJozunaDuration(response.data.total_duration);
        setCardData(sortedCourseData);
        setJozunaRecommendation("jozuna");
      }
      // ✅ AUTO SELECT FIRST COURSE
      if (sortedCourseData.length > 0) {
        const firstCourse = sortedCourseData[0];

        setSelectedCourse(firstCourse);

        // ✅ PASS programId directly
        getCourseTopic(firstCourse.course_id, id);
      }
    } catch (error) {
      Logger.info("error response", error);
      if (activeTab == 1) {
        setIndustryData([]);
        setIndustryDuration(0);
      } else {
        setJozunaDuration(0);
        setCardData([]);
      }
    } finally {
      Loader.dismissLoading();
      setLoading(false);
    }
  };
  const [selectedCourse, setSelectedCourse] = useState<any>(null);

  const handleCourseClick = (course: any) => {
    setSelectedCourse(course);
    getCourseTopic(
      course.course_id,
      selectedOptionJozuna?.id || selectedOption?.id || "",
    ); // safe after load
  };
  const toggleDetail = (index: number) => {
    if (openDetailIndex === index) {
      recommendationJozunaViewInstance_Store.setOpenedIndex(null);
      setOpenDetailIndex(
        recommendationJozunaViewInstance_Store.getOpenedIndex()!,
      );
    } else {
      recommendationJozunaViewInstance_Store.setOpenedIndex(index);
      setOpenDetailIndex(
        recommendationJozunaViewInstance_Store.getOpenedIndex()!,
      );
    }
  };
  const active = 0;
  return (
    <div
     
    >
       <RecommendationViewHeader
          text={`${state.programName} > ${state.course_name}`}
          hours={""}
          onClick={() => {
            navigate("/dashboard/recommendation/jozunaview");
          }}
        />
      {" "}
      <div style={{ backgroundColor: "transparent", height: "100vh" }}>
       

        <Row
          style={{
            marginTop: "30px",
            paddingLeft: "20px",
            paddingRight: "15px",
          }}
        >
          <Col lg={4} className="Jozuna-left-column">
            <div
              className="Jozuna-left-column-content"
              // style={{ paddingLeft: "20px" }}
            >
              {/* <h3 className="courseTitle">{`Course: ${state.course_name}`}</h3>
              {totVideos !== null && totVideos !== undefined && (
                // <p className="totalVideos">Total videos: {totVideos}</p>
                <p className="totalVideos">
                  Total Video{totVideos > 1 ? "s" : ""}: {totVideos}
                </p>
              )} */}
              {topicList?.length !== 0 ? (
                <ul className="list scrollable-list">
                  {topicList?.map((item) => (
                    <li
                      key={item.topic_id}
                      // onClick={() =>{handleCourseClick(item)}}
                      onClick={() => handleItemClick(item, true)}
                      className={`list-item ${
                        selectedTopic?.topic_id === item.topic_id
                          ? "selected"
                          : ""
                      }`}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <div style={{ minWidth: 0, flexGrow: 1 }}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              marginRight: "10px",
                            }}
                          >
                            <TopicNameTitleTextComponent
                              title={item.topic_title}
                            />
                            {item.is_new == true && <NewImage />}
                          </div>
                          {/* <h1
                            className="jozuna-list-title"
                            style={{
                              whiteSpace: "nowrap",
                              overflow: "visible",
                            }}
                          >
                            {item.topic_title}
                          </h1> */}
                          <div
                            style={{
                              display: "flex",
                              marginTop: "5px",
                              alignItems: "center",
                            }}
                          >
                            <p
                              style={{ fontSize: "0.8rem" }}
                              className="list-child"
                            >
                              <span
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "6px",
                                }}
                              >
                                <img
                                  src={dotImg}
                                  alt="dot"
                                  style={{
                                    width: "6px",
                                    height: "6px",
                                  }}
                                />

                                {`${item.number_of_videos} ${
                                  item.number_of_videos > 1 ? "videos" : "video"
                                }`}
                                <img
                                  src={dotImg}
                                  alt="dot"
                                  style={{
                                    width: "6px",
                                    height: "6px",
                                  }}
                                />

                                {`${item.number_of_files} ${
                                  item.number_of_files > 1
                                    ? "Documents"
                                    : "Document"
                                }`}
                              </span>
                            </p>
                          </div>
                          {/* <div className="view-details-btn"  onClick={(e) => {
    e.stopPropagation();

    setSelectedCourseInfo(item);
    setShowInfoModal(true);
  }}>
  View Details 
  <img
    src={infoImg}
    alt="info"
    style={{ width: "14px", height: "14px" }}
  />
</div> */}
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              ) : (
                <NoTopicsFound />
              )}{" "}
            </div>

            {/* <BlueVerticalDivider /> */}
          </Col>
          <Col
            md={8}
            style={{
              padding: 0,
              paddingLeft: 12,
              paddingRight: 25,
              backgroundColor: "#ffffff",
            }}
          >
            {/* {topicList?.length !== 0 ? (
  <ul className="topic-tab-list">
    {topicList?.map((item) => (
      <li
        key={item.topic_id}
        onClick={() => handleItemClick(item, true)}
        className={`topic-tab ${
          selectedItem?.topic_id === item.topic_id ? "active" : ""
        }`}
      >
        <div className="tab-title">
          {item.topic_title}
        </div>

       <div
  className="tab-sub"
  style={{
    display: "flex",
    alignItems: "center",
    gap: "6px",
  }}
>
  <img
    src={dotImg}
    alt="dot"
    style={{
      width: "6px",
      height: "6px",
    }}
  />

  {item.number_of_videos}{" "}
  {item.number_of_videos > 1 ? "Videos" : "Video"}
</div>
      </li>
    ))}
  </ul>
) : (
  <NoTopicsFound />
)} */}
            {selectedItem && (
              <div
                className="container-scroll"
                style={{
                  padding: 0,
                  paddingTop: 0,
                  height: "85vh",
                  overflow: "auto",
                  backgroundColor: "#fff",
                }}
              >
                {details?.videos?.map((detail, index) => (
                  <div
                    key={index}
                    style={{
                      marginBottom: "20px",
                      borderBottom: "1px solid #ddd",
                      backgroundColor: "#e7efff",
                      borderRadius: "40px",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                      overflow: "hidden",
                      // maxHeight: openDetailIndex === index ? "none" : "300px",
                    }}
                  >
                    <div
                      className="detail-header"
                      onClick={() => toggleDetail(index)}
                    >
                      <h4 className="detail-title">{detail.sub_topic}</h4>
                      <span
                        style={{
                          fontSize: "14px",
                          fontWeight: 400,
                          paddingRight: "10px",
                          color: "#6c6c6c",
                          marginLeft: "auto",

                          flexShrink: 0,
                        }}
                      >
                        {/* {`${detail?.list_videos} ${detail?.list_videos} > 1 ? 'videos' : 'video'}`} */}
                        <span
                          style={{
                            fontSize: "14px",
                            fontWeight: 400,
                            paddingRight: "10px",
                            color: "#6c6c6c",
                            marginLeft: "auto",
                            flexShrink: 0,
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                          }}
                        >
                          <img
                            src={dotImg}
                            alt="dot"
                            style={{
                              width: "6px",
                              height: "6px",
                            }}
                          />

                          {`${detail.list_videos.length} ${
                            detail.list_videos.length > 1 ? "videos" : "video"
                          }`}
                        </span>
                      </span>
                      <span
                        style={{
                          paddingLeft: "10px",
                          fontSize: "18px",
                          transition: "transform 0.3s",
                          transform:
                            openDetailIndex === index
                              ? "rotate(180deg)"
                              : "rotate(0deg)",
                        }}
                      >
                        <img
                          src={arrowImg}
                          alt="Toggle"
                          style={{ height: "9px", width: "16px" }}
                        />
                      </span>
                    </div>

                    <Collapse isOpen={openDetailIndex === index}>
                      <div
                        style={{
                          paddingTop: "10px",
                          paddingLeft: "20px",
                          paddingBottom: "20px",
                        }}
                      >
                        <div className="scroll-container">
                          {detail?.list_videos.map((image, imgIndex) => (
                            <div key={imgIndex} className="image-item">
                              <VideoImageOverlay
                                videoUrl={image.video_thumbnail}
                                newFlag={image.is_new}
                                width="326px"
                                height="200px"
                                playBtnheight="77px"
                                playBtnwidth="89px"
                                onClick={() =>
                                  navigate(
                                    "/dashboard/recommendation/jozunaview/video",
                                    {
                                      state: {
                                        video_id: image.video_id, //For initial video to play
                                        topic_id: selectedItem?.topic_id, //videos topic  id
                                        video_list: detail.list_videos, //for video thumbnail & video id
                                        course_name: selectedCourse.course_name, //course name
                                        course_id: selectedCourse.course_id, //Course Id
                                        course_topic: `${selectedItem?.topic_title} → ${detail.sub_topic}`, //videos topic title
                                        program_id: selectedOptionJozuna?.id,
                                        program_name: state.programName,
                                        program_category: "Jozuna",
                                      },
                                    },
                                  )
                                }
                              />
                              <div>
                                <h5 className="imageTitle">
                                  {image.video_title}
                                </h5>
                                <p className="imageDate">
                                  {CommonUtils.formatAllRegionDate(
                                    image.video_posted_on,
                                  )}
                                </p>
                                <p className="imagedesc">
                                  {image.video_description}
                                </p>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </Collapse>
                  </div>
                ))}{" "}
              </div>
            )}
          </Col>
        </Row>
      </div>
      {showInfoModal && selectedCourseInfo && (
        <div className="recommendation-info-overlay">
          <div className="recommendation-info-modal">
            {/* Header */}
            <div className="recommendation-info-header">
              <h3>Information</h3>

              <button
                className="recommendation-info-close"
                onClick={() => setShowInfoModal(false)}
              >
                ✕
              </button>
            </div>

            {/* Image */}
            <img
              src={selectedCourseInfo.course_thumbnail}
              alt="thumbnail"
              className="recommendation-info-image"
            />

            {/* Content */}
            <div className="recommendation-info-content">
              <h2>{selectedCourseInfo.course_title}</h2>

              <p>{selectedCourseInfo.course_description}</p>

              <div className="recommendation-info-footer">
                <span>• {selectedCourseInfo.total_videos} Videos</span>

                {selectedCourseInfo.is_new && (
                  <span className="recommendation-new-badge">NEW</span>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RecommendationJozunaViewCoursePage;
